module.exports = __webpack_public_path__ + "static/media/3_.55078db6.jpeg";